<div class="related-container">
  <button class="scroll-btn left" *ngIf="showLeftArrow" (click)="scrollLeft()">&#9665;</button>

  <div class="related" #scrollContainer (scroll)="checkOverflow()">
    <ng-container *ngFor="let item of relatedDashboards">
      <button
        class="related-button"
        (click)="gotoDashboard(item.id)"
        [ngClass]="{ selected: canvasId == item.id }"
        [matTooltip]="canvasId == item.id ? item.description : null"
        matTooltipClass="report-home-tooltip"
      >
        {{ item.name }}
      </button>
    </ng-container>
  </div>

  <button class="scroll-btn right" *ngIf="showRightArrow" (click)="scrollRight()">&#9655;</button>
</div>
